import errorHandler from './error-handler'

export function setupAppErrorHandling(app, appName = 'app') {
  if (!app || typeof app.config !== 'object') {
    console.warn(`[VueAppHelper] Invalid Vue app instance for ${appName}`)
    return app
  }

  errorHandler.setupVue3ErrorHandler(app)

  return app
}

export async function createAppWithErrorHandling(rootComponent, options = {}) {
  const { createApp } = await import('vue')
  const { appName = 'app', i18n, plugins = [], install } = options

  const app = createApp(rootComponent)

  if (i18n) {
    app.use(i18n)
  }

  plugins.forEach((plugin) => {
    if (plugin) app.use(plugin)
  })

  if (typeof install === 'function') {
    install(app)
  }

  setupAppErrorHandling(app, appName)

  return app
}

export function safeMount(app, element) {
  try {
    return app.mount(element)
  } catch (error) {
    console.error('[VueAppHelper] Failed to mount app:', error)
    errorHandler.handleGlobalError(error, {
      type: 'app-mount',
      element: typeof element === 'string' ? element : element?.id
    })
    throw error
  }
}
